<div class="main-content pt-4 mt-0">
  <div class="container-fluid">
    <div class="row justify-content-center">
      <div class="col-4 col-md-2" *ngFor="let card of resumenCards; index as i">
        <!-- [class]="i < 2 ? 'col-md-6' : 'col-md-4'" -->
        <div
          class="card card-stats"
          [ngClass]="{ 'card-stats__selected': i === 0 }"
          [routerLink]="card.route"
          [style.cursor]="card.route ? 'pointer' : 'default'"
        >
          <div class="card-body">
            <div class="row">
              <div class="col-12 col-md-7 col-lg-6">
                <div
                  class="icon-big text-center text-dark rounded shadow"
                  [ngClass]="card.bgClass"
                >
                  <i [class]="card.icon"></i>
                </div>
              </div>
              <div class="col-7 d-flex flex-column justify-content-center">
                <p class="card-category mb-0">{{ card.label }}</p>
                <h4
                  class="card-title mb-0"
                  [ngClass]="{ 'text-dark': i === 0, 'text-white': i !== 0 }"
                >
                  {{ card.value }}
                </h4>
              </div>
            </div>
          </div>
          <div class="card-footer">
            <div class="stats">
              <small [class]="i == 0 ? 'desc__selected' : 'desc'">{{
                card.desc
              }}</small>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-md-10 mx-auto">
        <div class="card">
          <div class="card-header card-header-icon">
            <div class="card-icon">
              <i class="material-icons">link</i>
            </div>
            <h4 class="card-title">View Backlink</h4>
          </div>
          <div class="card-body">
            <form [formGroup]="form">
              <div class="row">
                <div class="col-md-6">
                  <div class="form-group">
                    <label class="bmd-label-floating" for="sourceDomain"
                      >Source Domain</label
                    >
                    <input
                      type="text"
                      class="form-control"
                      id="sourceDomain"
                      formControlName="sourceDomain"
                    />
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="form-group">
                    <label class="bmd-label-floating" for="anchorText"
                      >Anchor Text</label
                    >
                    <input
                      type="text"
                      class="form-control"
                      id="anchorText"
                      formControlName="anchorText"
                    />
                  </div>
                </div>
              </div>

              <div class="row">
                <div class="col-md-12">
                  <div class="form-group">
                    <label class="bmd-label-floating" for="sourceUrl"
                      >Source URL</label
                    >
                    <input
                      type="text"
                      class="form-control"
                      id="sourceUrl"
                      formControlName="sourceUrl"
                    />
                  </div>
                </div>
              </div>

              <div class="row">
                <div class="col-md-12">
                  <div class="form-group">
                    <label class="bmd-label-floating" for="targetUrl"
                      >Target URL</label
                    >
                    <input
                      type="text"
                      class="form-control"
                      id="targetUrl"
                      formControlName="targetUrl"
                    />
                  </div>
                </div>
              </div>

              <div class="row">
                <div class="col-md-4">
                  <div class="form-group">
                    <label class="bmd-label-floating" for="relType"
                      >Rel Type</label
                    >
                    <select
                      class="form-control"
                      id="relType"
                      formControlName="relType"
                    >
                      <option *ngFor="let rel of relTypes" [value]="rel.value">
                        {{ rel.label }}
                      </option>
                    </select>
                  </div>
                </div>
                <div class="col-md-4">
                  <div class="form-group">
                    <label class="bmd-label-floating" for="linkPlacement"
                      >Link Placement</label
                    >
                    <select
                      class="form-control"
                      id="linkPlacement"
                      formControlName="linkPlacement"
                    >
                      <option
                        *ngFor="let p of linkPlacements"
                        [value]="p.value"
                      >
                        {{ p.label }}
                      </option>
                    </select>
                  </div>
                </div>
                <div class="col-md-4">
                  <div class="form-group">
                    <label class="bmd-label-floating" for="backlinkStatus"
                      >Status</label
                    >
                    <select
                      class="form-control"
                      id="backlinkStatus"
                      formControlName="backlinkStatus"
                    >
                      <option
                        *ngFor="let s of backlinkStatuses"
                        [value]="s.value"
                      >
                        {{ s.label }}
                      </option>
                    </select>
                  </div>
                </div>
              </div>

              <div class="row">
                <div class="col-md-6">
                  <div class="form-group">
                    <label class="bmd-label-floating" for="firstSeenAt"
                      >First Seen</label
                    >
                    <input
                      type="date"
                      class="form-control"
                      id="firstSeenAt"
                      formControlName="firstSeenAt"
                    />
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="form-group">
                    <label class="bmd-label-floating" for="lastSeenAt"
                      >Last Seen</label
                    >
                    <input
                      type="date"
                      class="form-control"
                      id="lastSeenAt"
                      formControlName="lastSeenAt"
                    />
                  </div>
                </div>
              </div>

              <div class="row">
                <div class="col-md-4">
                  <div class="form-group">
                    <label class="bmd-label-floating" for="authorityScore"
                      >Authority Score</label
                    >
                    <input
                      type="number"
                      class="form-control"
                      id="authorityScore"
                      formControlName="authorityScore"
                    />
                  </div>
                </div>
                <div class="col-md-4">
                  <div class="form-group">
                    <label class="bmd-label-floating" for="relevanceScore"
                      >Relevance Score</label
                    >
                    <input
                      type="number"
                      class="form-control"
                      id="relevanceScore"
                      formControlName="relevanceScore"
                    />
                  </div>
                </div>
                <div class="col-md-4">
                  <div class="form-group">
                    <label class="bmd-label-floating" for="spamRisk"
                      >Spam Risk</label
                    >
                    <input
                      type="number"
                      class="form-control"
                      id="spamRisk"
                      formControlName="spamRisk"
                    />
                  </div>
                </div>
              </div>

              <div class="row">
                <div class="col-md-4">
                  <div class="form-group">
                    <label class="bmd-label-floating" for="acquisitionType"
                      >Acquisition Type</label
                    >
                    <select
                      class="form-control"
                      id="acquisitionType"
                      formControlName="acquisitionType"
                    >
                      <option
                        *ngFor="let a of acquisitionTypes"
                        [value]="a.value"
                      >
                        {{ a.label }}
                      </option>
                    </select>
                  </div>
                </div>
              </div>

              <div class="row">
                <div class="col-md-12">
                  <div class="form-group">
                    <label class="bmd-label-floating" for="notes">Notes</label>
                    <textarea
                      class="form-control"
                      id="notes"
                      formControlName="notes"
                      rows="3"
                    ></textarea>
                  </div>
                </div>
              </div>

              <div class="row mt-4">
                <div class="col-12 text-right">
                  <button
                    type="button"
                    class="btn btn-secondary"
                    (click)="goBack()"
                  >
                    Back
                  </button>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
